export function useLanguage() {
	const locale = localStorage.getItem("PARAGLIDE_LOCALE") as string;
	const lang =
		{
			zh: "zh",
			en: "en",
			id: "id",
			de: "de",
			fr: "fr",
			es: "es",
			ru: "ru",
		}[locale] || "en";
	return lang;
}
